angular.module('impactx.approval').directive('ixApprovalSelection', function($window) {
    return {
        scope: {
            id: '=',
            entries: '=',
            steps: '=',
            externalApprovalStep: '=',
            trns: '=',
            isAutomaticApproval: '=',
            isManualApproval: '=',
            isSelfApproval: '=',
            isOnlyExternalApproval: '=',
            hasSelfApproval: '=',
            templates: '=',
            name: "=",
            form: "="
        },
        restrict: 'E',
        controller: "ApprovalSelectionCtrl",
        controllerAs: 'ctrl',
        template: '<div ng-include="templateUrl"></div>',
        link: function(scope) {
            scope.templateUrl = 'shared/approval/templates/approval-selection.tmpl.html';
            $window.onresize = function() {
                changeTemplate();
                scope.$evalAsync();
            };
            changeTemplate();

            scope.$watch(function () {
                    return scope.steps && scope.steps.length;
                },
                function (newValue, oldValue)
                {
                    if (newValue !== oldValue) {
                        changeTemplate();
                        scope.$evalAsync();
                    }
                }
            );

            function changeTemplate() {
                var maxWidth = scope.steps ? scope.externalApprovalStep ? 320 * (scope.steps.length + 1) : 320 * scope.steps.length : 0;
                if(angular.element("#ix-main-view").width() - 300 < maxWidth) {
                    scope.templateUrl = 'shared/approval/templates/approval-selection-vertical.tmpl.html';
                }
                else
                {
                    scope.templateUrl = 'shared/approval/templates/approval-selection.tmpl.html';
                }
            }
        }
    }
});
